export class IDType {
    IDType;
    CDesc;
    EDesc;
    constructor() {
      this.IDType = "";
      this.CDesc = "";
      this.EDesc = "";
    }
  }
  


// WEBPACK FOOTER //
// ./src/model/IDType.js